import { openModal, closeModal } from "../../CoreModules/Modal/actionCreators"

export default (mapDispatch) => (dispatch, ownProps) => ({
  ...mapDispatch(dispatch, ownProps),
  openModal: ({
    component,
    enrichingState = () => {},
    enrichingDispatch = () => {},
    inheritedFunctions = {},
    hideCloseIcon = false,
    shouldCloseOnOverlayClick = true,
  }) =>
    dispatch(
      openModal({
        component,
        enrichingState,
        enrichingDispatch,
        inheritedFunctions,
        hideCloseIcon,
        shouldCloseOnOverlayClick,
      })
    ),
  closeModal: () => dispatch(closeModal()),
})
